import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Card, message } from "antd";
import { DefaultForm } from "../../components";
import { useGetCurrentUserQuery, useLoginMutation } from "../../features/identity/identityApi";
import BoniboLoader from "../../components/loaders/BoniboLoader";
import { LoginModel } from "../../entities/auth";
import { ApiError } from "../../utils/errorUtils";
import { useTranslation } from "react-i18next";

export const LoginPage = () => {
  const [t] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [loginActionDone, setLoginActionDone] = useState(false);
  const { data: currentUser, isLoading: isLoadingUser, isUninitialized: isUninitializedUser, isFetching: isFetchingUser } = useGetCurrentUserQuery();
  const [login] = useLoginMutation();
  const [loading, setLoading] = useState(false);

  const userIsLoggedIn = useMemo(() => currentUser !== undefined, [currentUser]);

  const model = { userName: "", password: "" };

  const loginUser = useCallback(
    async (loginModel: LoginModel) => {
      setLoading(true);
      message.loading({ content: "در حال ورود", key: "loginUser", duration: 0 });
      try {
        await login(loginModel).unwrap();
        message.success({
          content: "ورود با موفقیت انجام شد",
          key: "loginUser",
          duration: 5,
        });
        setLoginActionDone(true);
      } catch (error) {
        // Ensure we're handling normalized ApiError
        const apiError = error as ApiError;
        if (apiError.globalErrors.length > 0) {
          message.error({
            content: t(`errors:${apiError.globalErrors[0]}`, apiError.params),
            key: "loginUser",
            duration: 5,
          });
        } else {
          message.error({
            content: "عملیات ورود با خطا مواجه شد",
            key: "loginUser",
            duration: 5,
          });
        }
      } finally {
        setLoading(false);
        // if (notificationKey) {
        //   dismissNotification(notificationKey);
        // }
      }
    },
    [login, t]
  );

  const queryString = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
  useEffect(() => {
    if (loginActionDone && userIsLoggedIn) {
      const returnUrl = queryString.get("returnUrl");
      if (returnUrl) {
        returnUrl.startsWith("http") ? (document.location.href = returnUrl) : navigate(returnUrl);
      } else {
        navigate("/");
      }
    }
  }, [userIsLoggedIn, loginActionDone, queryString, navigate]);

  if (isLoadingUser || isUninitializedUser || isFetchingUser) {
    return <BoniboLoader />;
  }

  return (
    <div className="bg-gray-100 p-5 " style={{ minHeight: "100vh", paddingTop: "calc(10vh)" }}>
      <Card className="md:w-1/2 lg:w-1/3 mx-auto rounded-lg" title="ورود به بنیبو">
        <DefaultForm initialValues={model} layout="vertical" onFinish={loginUser}>
          <div>
            <DefaultForm.TextInput name="userName" rules={[{ required: true }]} />
            <DefaultForm.PasswordInput name="password" rules={[{ required: true }]} />

            <div className="relative mb-4">
              <Link to="/forgotPassword" className="mb-6 text-base">
                رمز عبور خود را فراموش کرده اید؟
              </Link>
            </div>

            <DefaultForm.SubmitButton loading={isLoadingUser || loading}>ورود</DefaultForm.SubmitButton>
          </div>
        </DefaultForm>
      </Card>
    </div>
  );
};
